import { FadeIn, FadeInStagger } from "./FadeIn";

/**
 * Airon-designed page heading. Uses the design system dark "contact-cta" palette
 * so every inner page gets a consistent on-brand banner.
 *
 * Props:
 *  - title (string, required)
 *  - description (string)
 *  - eyebrow (string) small uppercase label rendered above title
 */
export const PageHeading = ({ title, description, eyebrow }) => {
  return (
    <FadeInStagger
      className="contact-cta"
      style={{ padding: "80px 0 64px" }}
    >
      <div className="wrap">
        <div style={{ maxWidth: "52rem", position: "relative" }}>
          {eyebrow ? (
            <FadeIn>
              <div
                className="eyebrow"
                style={{
                  background: "rgba(57,182,234,0.14)",
                  color: "#B5E5FA",
                  marginBottom: "24px",
                }}
              >
                <span className="dot" />
                {eyebrow}
              </div>
            </FadeIn>
          ) : null}
          <FadeIn>
            <h1
              className="display"
              style={{
                fontFamily: "var(--display)",
                fontWeight: 500,
                fontSize: "clamp(34px, 5vw, 56px)",
                lineHeight: 1.05,
                letterSpacing: "-0.025em",
                margin: 0,
                color: "#fff",
              }}
            >
              {title}
            </h1>
          </FadeIn>
          {description ? (
            <FadeIn>
              <p
                style={{
                  marginTop: "20px",
                  fontSize: "18px",
                  lineHeight: 1.6,
                  color: "#B5C4D3",
                  maxWidth: "52ch",
                }}
              >
                {description}
              </p>
            </FadeIn>
          ) : null}
        </div>
      </div>
    </FadeInStagger>
  );
};
